export { default } from './NewsSlider';
